const STORAGE_KEY = "prime_session_token";

function memoryGet(store: Storage): string | null {
  try {
    return store.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function memorySet(store: Storage, token: string): void {
  try {
    store.setItem(STORAGE_KEY, token);
  } catch {
    /* ignore quota / private mode */
  }
}

function memoryClear(store: Storage): void {
  try {
    store.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Prefer localStorage so refresh and new tabs keep the session. */
export function getStoredSessionToken(): string | null {
  const lasting = memoryGet(window.localStorage);
  if (lasting) {
    return lasting;
  }
  const tab = memoryGet(window.sessionStorage);
  if (tab) {
    memorySet(window.localStorage, tab);
    return tab;
  }
  return null;
}

export function setStoredSessionToken(token: string): void {
  memorySet(window.localStorage, token);
  memorySet(window.sessionStorage, token);
}

export function clearStoredSessionToken(): void {
  memoryClear(window.localStorage);
  memoryClear(window.sessionStorage);
}

export function peekStoredSessionUser(): { email: string; name: string } | null {
  const token = getStoredSessionToken();
  if (!token) {
    return null;
  }
  const body = token.split(".")[0];
  if (!body) {
    return null;
  }
  try {
    const pad = body.length % 4 === 0 ? "" : "=".repeat(4 - (body.length % 4));
    const json = atob(body.replace(/-/g, "+").replace(/_/g, "/") + pad);
    const payload = JSON.parse(json) as { email?: string; name?: string; exp?: number };
    if (typeof payload.exp === "number" && payload.exp < Math.floor(Date.now() / 1000)) {
      clearStoredSessionToken();
      return null;
    }
    if (!payload.email) {
      return null;
    }
    return { email: payload.email, name: payload.name || payload.email };
  } catch {
    return null;
  }
}
